import "./HideFrom.scss";
import { ReactNode } from "react";
import cn from "classnames";

export enum Breakpoint {
  Tablet = "tablet",
  Desktop = "desktop",
  DesktopMedium = "desktopMedium",
  DesktopLargeUp = "desktopLargeUp",
}

interface GridCell {
  children: ReactNode;
  breakpoint?: Breakpoint;
}

const HideFrom = ({ children, breakpoint }: GridCell) => {
  const classes = cn("hide-from-norad", {
    "hide-from-norad--tablet": breakpoint === Breakpoint.Tablet,
    "hide-from-norad--desktop": breakpoint === Breakpoint.Desktop,
    "hide-from-norad--desktop-large-up":
      breakpoint === Breakpoint.DesktopLargeUp,
  });

  return <div className={classes}>{children}</div>;
};

export default HideFrom;
